import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminRoute } from './components/AdminRoute';

// Pages
import { HomePage } from './pages/HomePage';
import { ContactPage } from './pages/ContactPage';
import { MembersPage } from './pages/MembersPage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { VerifyEmailPage } from './pages/VerifyEmailPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { PortalPage } from './pages/PortalPage';
import { AdminPage } from './pages/AdminPage';
import { BestPracticesPage } from './pages/BestPracticesPage';

const queryClient = new QueryClient();

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AuthProvider>
          <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--c-surface)' }}>
            <Navbar />
            <main style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<HomePage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/members" element={<MembersPage />} />

                {/* Auth Routes */}
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/verify-email" element={<VerifyEmailPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />

                {/* Protected Routes - Portal */}
                <Route
                  path="/portal"
                  element={
                    <ProtectedRoute>
                      <PortalPage />
                    </ProtectedRoute>
                  }
                />

                {/* Legacy protected routes for direct access */}
                <Route path="/documents" element={<Navigate to="/portal" replace />} />
                <Route path="/meetings" element={<Navigate to="/portal" replace />} />
                <Route
                  path="/best-practices"
                  element={
                    <ProtectedRoute>
                      <BestPracticesPage />
                    </ProtectedRoute>
                  }
                />
                <Route path="/discussions" element={<Navigate to="/portal" replace />} />

                {/* Admin Routes */}
                <Route
                  path="/portal/admin"
                  element={
                    <ProtectedRoute>
                      <AdminRoute>
                        <div className="page">
                          <div className="container" style={{ paddingTop: 32, paddingBottom: 48 }}>
                            <AdminPage />
                          </div>
                        </div>
                      </AdminRoute>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminRoute>
                        <div className="page">
                          <div className="container" style={{ paddingTop: 32, paddingBottom: 48 }}>
                            <AdminPage />
                          </div>
                        </div>
                      </AdminRoute>
                    </ProtectedRoute>
                  }
                />

                {/* Catch all */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </AuthProvider>
      </Router>
    </QueryClientProvider>
  );
};

export default App;
